import type { FaireProductEntity } from "../../entity_types/product";

export const p_29hpx9u8hv: FaireProductEntity = {
  token: "p_29hpx9u8hv",
  type: "product",
  name: "FRENCH GARDEN COTTON LINEN LONG DRESS",
  brandToken: "b_m8aq2q3qv8",
  brandName: "Lily Clothing",
  imageUrl:
    "https://cdn.faire.com/fastly/696a1355c212822b502dd0b25812ede143bddac08f4123d1d83e601d8791e004.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/91ba23a85849a2bb6ecd9196b807fd4386d24842a7dfdd5ef8529399fe59ba15.jpeg",
    "https://cdn.faire.com/fastly/99c6afc388a7e163b964a672a44acbaceba797445611815a5f6e923c44c3efd9.jpeg",
    "https://cdn.faire.com/fastly/dade422aa28f72ced4333242e0d9f94ac12fd16bdb18de4b4d98c2a1f9628898.jpeg",
    "https://cdn.faire.com/fastly/2ea5002d9962c7c73928464b1b9b9487b539ebd4c8104d3c493ad86a4bb870f4.jpeg",
    "https://cdn.faire.com/fastly/d2b3b1e60addcab7f5cd27b24a10261d2d405da215a301cd5e62d2ed8bea651f.jpeg",
    "https://cdn.faire.com/fastly/7ccacfbfdfa30713de0e5cad3f48fa0a60cd62db1d2d0dde2420dcd13f140199.jpeg",
    "https://cdn.faire.com/fastly/59f7e33d4be9237819c1b250f854f4929daa3a15671fc2edb6533fae197a2e17.jpeg",
    "https://cdn.faire.com/fastly/732dcb089f5c1a064f8b128bb75bdc74dac6d1bdbdc11ea955b22307fb7d6901.jpeg",
    "https://cdn.faire.com/fastly/79a2c80ece368a218f13fecb73c88e88bc8c2a3f357a3307c2ed52623a85f120.jpeg",
  ],
  priceDollars: 39.95,
  description:
    "French Garden Cotton Linen Long Dress\n30% cotton, 70% linen\nSizes: OS\nMade in China\n\nwomen blazer, bathing suits, crochet cardigan, cable knit sweater, wholesale t shirts, beach cover ups, ruffle dress, eyelet blouse, puff sleeve top, floral dress, women t shirt, women shorts, women dress, women pants, bohemian, western sweater, summer top, summer t shirt, summer dress, maxi dress, summer tee, women summer top, summer blouse, spring apparel, 2024 women apparel, western, western apparel, holiday shirts, plus size clothing, new products, women dress, women clothing, spring, summer, women dresses summer, skirt, long skirt, summer skirt, summer vest, pockets, floral t shirt, denim shorts, jeans, women sets, summer apparel, holiday, tank top, vest, blouses dress, oversied, plus size, sundress, chiffon, casual dress, sleepwear, botton down, beach dress, modest dress, formal dress, wedding dress, pink dress, women's shirt, dress, printed dress, pleated dress, father's day shirt, father's day, Mother's Day, father's day shirt",
  tags: [],
  msrpDollars: 79.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:41.906Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
